var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDlpProposalButtonCustomArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.93359 1.15625L5.84375 5.3125C5.95312 5.44922 6.03516 5.61328 6.03516 5.75C6.03516 5.91406 5.95312 6.07812 5.84375 6.21484L1.93359 10.3711C1.6875 10.6445 1.27734 10.6445 1.00391 10.3984C0.730469 10.1523 0.730469 9.74219 0.976562 9.46875L4.47656 5.75L0.976562 2.05859C0.730469 1.78516 0.730469 1.375 1.00391 1.12891C1.27734 0.882812 1.6875 0.882812 1.93359 1.15625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlpProposalButtonCustomArrow);
export default __webpack_public_path__ + "static/media/DlpProposalButtonCustomArrow.9030161a56ffcffa0c9ce25bbb91b2a5.svg";
export { ForwardRef as ReactComponent };